// production
const config = {
  baseUrl: "https://app.sooni.sh",
  apiBaseUrl: "https://api.sooni.sh",
  apiKey: "fBrL6zASe3j7ESZJ3MaebqzerPRcOhXK",
  cookieDomain: ".sooni.sh",
  namespace: "soonish"
};

if (window.location.hostname === "localhost") {
  // development
  config.baseUrl = `http://${window.location.host}`;
  config.apiBaseUrl = "http://localhost:3000";
  config.apiKey = "wzaILy2jtT1p2Nwz9PHRodiIMUnR19ua";
  config.cookieDomain = "localhost";
} else if (window.location.hostname === "app-staging.sooni.sh") {
  // staging
  config.baseUrl = "https://app-staging.sooni.sh";
  config.apiBaseUrl = "https://api-staging.sooni.sh";
  config.apiKey = "svFrFO10H4yyMUhewrssvsTudh3jWscJ";
  config.cookieDomain = ".sooni.sh";
}

export default config;
